
import { axiosReadHelper } from "../../shared/service/axios-read-helper";
import { AxiosReadPayload } from "../../shared/service/axios-read-payload";
import { AxiosResultStatus } from "../../shared/service/axios-result-status";
import { PayerRow } from "../models/payers";
import { ConfigRiskClassSetting, FinPayRiskClass } from "../models/risk-class-setting";

class AdminConfigurationService {

  async configGetLOC(paramId: number): Promise<AxiosResultStatus> {
    const payload: AxiosReadPayload = {
      dataId: paramId,
      url: "configuration/v2/configuration/levelofcare",
    };

    return axiosReadHelper(payload);
  }

  async configGetPayers(paramId: number): Promise<AxiosResultStatus> {
    const baseUrl: string = "configuration/v2/configuration/payor";
    let lastResult: AxiosResultStatus | undefined = undefined;
    const limit = 1000;
    let offset = 0;
    let results: Array<PayerRow> = [];

    while (lastResult === undefined || lastResult.entity.length === limit) {
      const result: AxiosResultStatus = await axiosReadHelper({
        dataId: paramId,
        url: `${baseUrl}?offset=${offset}&limit=${limit}`,
      });
      offset += limit;
      lastResult = result;
      if (result.hasErrors) {
        return result;
      }
      results.push(...(result.entity as Array<PayerRow>));
    }

    lastResult.entity = results;
    return lastResult;
  }

  // url: "clients/v2/client/${clientId}/scholarship",
  async configGetScholarships(paramId: number, clientId: number): Promise<AxiosResultStatus> {
    const payload: AxiosReadPayload = {
      dataId: paramId,
      url: `clients/v2/client/${clientId}/scholarship`,
    };

    const responseData = await axiosReadHelper(payload);
    return responseData;

  }

  async configGetRiskThresholds(paramId: number): Promise<AxiosResultStatus> {
    const payload: AxiosReadPayload = {
      dataId: paramId,
      url: `configuration/v2/configuration/risk-threshold`,
    };

    const responseData = await axiosReadHelper(payload);
    return responseData;
  }


  async configGetFinPayRiskClasses(paramId: number): Promise<AxiosResultStatus> {
    const payload: AxiosReadPayload = {
      dataId: paramId,
      url: `clients/v2/risk-class`,
    };

    const responseData = await axiosReadHelper(payload);
    return responseData;
  }

  async configGetRiskClassSettings(paramId: number, finPayRiskClasses: FinPayRiskClass[]): Promise<AxiosResultStatus> {
    const payload: AxiosReadPayload = {
      dataId: paramId,
      url: `configuration/v2/configuration/risk-class-setting`,
    };

    const response = await axiosReadHelper(payload);
    const riskClassSettings = response.entity;

    if (!response.hasErrors) {
      const retData = this.mapToConfigRiskClassSettingForm(riskClassSettings, finPayRiskClasses);
      response.entity = retData;
    }

    return response;
  }

  mapToConfigRiskClassSettingForm(responseData: ConfigRiskClassSetting[], totalFinancialRiskClasses: FinPayRiskClass[]): ConfigRiskClassSetting[] {
    // eslint-disable-next-line no-lone-blocks
    {
      let workFinancialRiskClasses: ConfigRiskClassSetting[] = [];
      totalFinancialRiskClasses.forEach((x: FinPayRiskClass) => {
        const workRiskClassId = x.riskClassId;
        let newItem: ConfigRiskClassSetting = {
          fpRiskClassId: workRiskClassId,
          riskClassName: x.riskClassName,
          riskClassSettingId: undefined,
          riskClassCleared: undefined,
          riskClassHre: undefined,
        };

        let dataItem = responseData.find(item => item.fpRiskClassId === workRiskClassId);
        if (dataItem !== undefined) {
          newItem.riskClassCleared = dataItem.riskClassCleared;
          newItem.riskClassHre = dataItem.riskClassHre;
          newItem.riskClassSettingId = dataItem.riskClassSettingId;
        }
        workFinancialRiskClasses.push(newItem);
      })
      return workFinancialRiskClasses;
    }

  }

}

export const adminConfigurationService = new AdminConfigurationService();
